import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { patientKeys } from "@/features/patient/api/keyFactory";
import { usePatientDetails } from "@/features/patient/api/queries/usePatientDetails";

import { MemberProfile } from "./MemberProfile";

// Once we refactor all Profile tabs to functional components this will be deprecated
export function MemberProfileContainer(props) {
  const { patientId } = useParams();
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  const queryClient = useQueryClient();
  const { data: patientDetails } = usePatientDetails({ patientId });
  const waitlistChangeCount = useSelector((state) => state.patient.waitlistChangeCount);

  if (!patientDetails) return null;

  const refetchPatientDetails = () =>
    queryClient.invalidateQueries({ queryKey: patientKeys.details(patientId) });

  return (
    <MemberProfile
      {...props}
      history={history}
      location={location} // this replaces withRouter hoc
      match={match}
      patientDetails={patientDetails}
      refetchPatientDetails={refetchPatientDetails}
      waitlistChangeCount={waitlistChangeCount}
    />
  );
}
